import React, { Fragment, useEffect, useState } from "react";
import { Modal, Box } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import htmlToDraft from "html-to-draftjs";
import draftToHTML from "draftjs-to-html";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import PreviewModal from "./PreviewModal";
import moment from "moment";
import Header from "./MailModalComponents/Header";
import InputArea from "./MailModalComponents/InputArea";
import BottomToolbar from "./MailModalComponents/BottomToolbar";
import ApiClient from "utils/ApiClient";
import styled from "styled-components";

const MailModal = ({ showMailMergeModal, closeModal, store }) => {
  const [mailData, setMailData] = useState({
    selectedTemplate: null,
    selectedDateAndTime: new Date(),
    selectedFromEmail: null,
    selectedToEmail: null,
    cc: "",
    subject: "",
    check: false,
    saveTemplate: false,
    showPreviews: false,
    openManageAccountModal: false,
    draftId: null,
    showAttachmentAlert: false,
    noOfAttachments: 0,
    showCcField: false,
    saveTemplateName: "",
    isPreviewLoading: false,
    isBulkMailSending: false,
  });

  const [columnsForMultiSelect, setColumnsForMultiSelect] = useState([]);
  const [isLoadingFetchDrafts, setIsLoadingFetchDrafts] = useState(false)
  const [change, setChange] = useState(false);
  const [variables, setVariables] = useState([]);
  const [from_emails, setFrom_emails] = useState([]);
  const [templates, setTemplates] = useState(null);
  const [timezones, setTimezones] = useState(null);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [previews, setPreviews] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const selectedNodesCount = store.noOfRecordsSelected;

  const toggleNewTemplate = () => {
    setEditorState(EditorState.createEmpty());
    setMailData({
      ...mailData,
      saveTemplate: false,
      selectedTemplate: null,
      draftId: null,
      showAttachmentAlert: false,
      noOfAttachments: 0,
      showCcField: false,
      subject: "",
      selectedFromEmail: null,
      selectedToEmail: null,
      check: false,
      selectedDateAndTime: new Date(),
    });
  };

  const body = {
    list_id: store.listId,
    is_web: 1,
  };

  const fetch = async () => {
    try {
      const data = await ApiClient.MailMerge.getMailAccounts({ ...body, all: true });
      setFrom_emails(data.data);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const getTemplates = async () => {
    try {
      const data = await ApiClient.MailMerge.getTemplates(body);
      setTemplates(data.data);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const getTimezones = async () => {
    try {
      const data = await ApiClient.MailMerge.getTimezones(body);
      setTimezones(data.data);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const setVariablesforinsertvariable = () => {
    try {
      var cols = store.columnsFormatted;
      const variable = [
        { alias_path: `${store.props.view.name}.id` },
        ...cols,
        { alias_path: "ROW_ID" },
        ...store.containerStore.appStore.userStore.loggedInUserColumns,
      ];
      setVariables(variable);
    } catch (error) {
      // console.log(error);
    }
  };

  const getBody = () => {
    if (
      mailData.selectedFromEmail == null ||
      mailData.selectedToEmail == null ||
      mailData.selectedFromEmail === "connect_new"
    ) {
      mailData.selectedFromEmail === null || mailData.selectedFromEmail === "connect_new"
        ? showAlert("Please select a 'From' email account", false)
        : showAlert("Please select a 'To' email field", false);
      return false;
    }

    if (mailData.subject == null || mailData.subject.length < 1) {
      showAlert("Please Add Subject", false);
      return false;
    }

    const params = {};
    params.list_id = store.listId;
    params.mail_account_id = mailData.selectedFromEmail;
    params.to_email_column = mailData.selectedToEmail;
    params.cc = mailData.showCcField ? (mailData.cc.length ? [mailData.cc] : '""') : '""';
    params.template_type = mailData.draftId ? mailData.draftId : mailData.selectedTemplate ? 2 : 1;
    params.draft_id = mailData.draftId ? mailData.draftId : "";
    params.template_id = mailData.selectedTemplate ? mailData.selectedTemplate : "";
    params.subject = mailData.subject;
    params["textfield-1279-inputEL"] = "";
    params["ckeditor-1277-inputEL"] = "";
    if (mailData.check) {
      params.schedule_later = "on";
      let at = moment(mailData.selectedDateAndTime).format("YYYY-MM-DD HH:mm:ss");
      params.scheduled_at = at;
      params.scheduled_at_tz = mailData.selectedTimezone;
    } else {
      params.scheduled_at = "";
      params.scheduled_at_tz = "Asia/Calcutta";
    }
    if (mailData.saveTemplate) {
      params.save_template = "on";
    }
    params.save_template_name = mailData.saveTemplateName && mailData.saveTemplateName != "" ? mailData.saveTemplateName : mailData.subject;
    params.name = "";
    params.body = draftToHTML(convertToRaw(editorState.getCurrentContent()));
    var criteria = [];
    let selectedNodes = store.gridApi.getSelectedNodes();
    selectedNodes.map((node) => {
      if (node?.data?.row_id) {
        criteria.push(node.data.row_id);
      }
      return 1;
    });
    if(criteria.length <= 0){
      showAlert("Invalid Rows", false);
      return false;
    }
    var crstring = criteria.join(",");
    params.criteria = crstring;
    params.list_name = store.props.view.name;
    params.view_id = store.viewId;
    params.is_web = 1;
    return params;
  };

  const preview = async () => {
    const body = getBody();
    if (body === false) {
      return;
    } else {
      try {
        setMailData({ ...mailData, isPreviewLoading: true });
        const data = await ApiClient.MailMerge.preview(body);
        setMailData({ ...mailData, isPreviewLoading: false });
        if (!data.success) {
          showAlert(data.msg ? data.msg : "Something went wrong", false);
          return;
        } else {
          setPreviews(data.data);
          setMailData({ ...mailData, showPreviews: true });
          const numberOfRows = body.criteria.split(",");
          if (numberOfRows.length > 5) {
            window.appStore.notificationStore.showNotification(
              "This is the preview of first 5 rows",
              "info"
            );
          }
        }
      } catch (error) {
        setMailData({ ...mailData, isPreviewLoading: false });
        showAlert("Something went wrong. Please try again later.", false);
      }
    }
  };

  const create = async () => {
    const body = getBody();
    if (body === false) return;
    try {
      setMailData({ ...mailData, isBulkMailSending: true });
      const data = await ApiClient.MailMerge.create(body);
      setMailData({ ...mailData, isBulkMailSending: false });
      if (!data.success) {
        showAlert(data.msg !== undefined ? data.msg : "Something went wrong", false);
      } else {
        showAlert(mailData.check ? "Scheduled" : "Success", true);
        setTimeout(() => {
          closeModal();
          // window.appStore?.containerStore?.loadGrid?.();
          window.appStore?.containerStore?.currentViewStore?.unselectSelectedRowsInGrid();
        }, 500);
      }
    } catch (error) {
      setMailData({ ...mailData, isBulkMailSending: false });
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const addAccount = async () => {
    let win = window.open(
      window.mainDomain +
        "/oauth/return_mails.php?list_id=" +
        store.listId +
        "&return_url=" +
        encodeURI(window.serverUrl + "/api/mail-campaign/google-sign-in")
    );
    var timer = setInterval(() => {
      if (win.closed) {
        clearInterval(timer);
        fetch();
      }
    }, 1000);
    setMailData({ ...mailData, selectedFromEmail: null });
  };

  const deleteAccount = async (id) => {
    try {
      if(mailData.selectedFromEmail == id){
        setMailData({ ...mailData, selectedFromEmail: null });
      }
      const data = await ApiClient.MailMerge.deleteAccount({ id, is_web: 1 });
      if (!data.success) {
        showAlert(data.msg != undefined ? data.msg : "Something went wrong", false);
      } else {
        showAlert("The account has been deleted successfully", true);
      }
      setChange(!change);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const reconnectAccount = async (id) => {
    try {
      const data = await ApiClient.MailMerge.reconnectAccount({ id, is_web: 1 });
      if (!data.success) {
        showAlert(data.msg != undefined ? data.msg : "Something went wrong", false);
      } else {
        showAlert("The account has been reconnected successfully", true);
      }
      setChange(!change);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const disconnectAccount = async (id) => {
    try {
      if(mailData.selectedFromEmail == id){
        setMailData({ ...mailData, selectedFromEmail: null });
      }
      const data = await ApiClient.MailMerge.disconnectAccount({ id, is_web: 1 });
      if (!data.success) {
        showAlert(data.msg != undefined ? data.msg : "Something went wrong", false);
      } else {
        showAlert("The account has been disconnected successfully", true);
      }
      setChange(!change);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const deleteTemplate = async (id) => {
    try {
      const data = await ApiClient.MailMerge.deleteTemplate({ id, is_web: 1 });
      if (!data.success) {
        showAlert(data.msg != undefined ? data.msg : "Something went wrong", false);
      } else {
        showAlert("The template has been deleted successfully", true);
      }
      setChange(!change);
    } catch (error) {
      showAlert("Something went wrong. Please try again later.", false);
    }
  };

  const set_mails = () => {
    TL.list.reports.ColumnsFormatter.getViewColumns(
      store.listConfig.list,
      store.view,
      Ext.bind(function (columns) {
        let currentSheetColumns = TL.list.settings.lookup.CriteriaHelper.formatColumns(columns, {
          listNameStr: store.listConfig.list.name,
        });
        setColumnsForMultiSelect(currentSheetColumns.filter((col) => col.column_type_id == "10" || col.column_type_id == "14"));
      })
    );
  };

  const populate = (id, isDrafts = false) => {
    if (isDrafts) {
      let draft = drafts.find((el) => el.id === id);
      try {
        setMailData({
          ...mailData,
          selectedTemplate: null,
          draftId: id,
          noOfAttachments: draft.attachments.length,
          subject: draft.subject,
          showAttachmentAlert: true,
        });
        let base64string = draft.body ? draft.body : "";
        let bufferObj = Buffer.from(base64string, "base64");
        let decodedString = bufferObj.toString("utf8");
        const blocksFromHtml = htmlToDraft(decodedString);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
        return;
      } catch (error) {
        setEditorState(EditorState.createEmpty());
        return;
      }
    } else {
      var select = templates.find((el) => el.id === id);
      if (select) {
        setMailData({
          ...mailData,
          showAttachmentAlert: false,
          draftId: null,
          subject: select.subject,
        });
        try {
          const blocksFromHtml = htmlToDraft(select.body);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
          const newEditorState = EditorState.createWithContent(contentState);
          setEditorState(newEditorState);
        } catch (error) {
          // console.log(error);
        }
      }
    }
  };
  const validateAccountFetchDrafts = async () => {
    if (!mailData.selectedFromEmail || mailData.selectedFromEmail == "connect_new") {
      return;
    }
    try {
      setIsLoadingFetchDrafts(true)
      const data = await ApiClient.MailMerge.validateAccount({
        list_id: store.listId,
        account_id: mailData.selectedFromEmail,
        is_web: 1,
      });
      setDrafts(data.data);
    } catch (error) {
      setDrafts([]);
      showAlert("Something went wrong. Please try again later.", false);
    } finally {
      setIsLoadingFetchDrafts(false)
    }
  };

  const showAlert = (msg, type) => {
    window.appStore.notificationStore.showNotification(msg, type ? "success" : "error");
  };

  useEffect(() => {
    fetch();
    set_mails();
    getTemplates();
    getTimezones();
    setVariablesforinsertvariable();
    validateAccountFetchDrafts();
  }, [change, showMailMergeModal]);

  return (
    <Fragment>
      <Snackbar
        open={mailData.showAttachmentAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        message={`This Draft has ${mailData.noOfAttachments} Attachments`}
      />
      <PreviewModal previews={previews} mailData={mailData} setMailData={setMailData} />
      <Modal open={showMailMergeModal} onClose={closeModal}>
        <StyledBox>
          <Header closeModal={closeModal} modelView={showMailMergeModal} />
          <InputAreaWrapper>
            <InputArea
              from_emails={from_emails}
              editorState={editorState}
              setEditorState={setEditorState}
              variables={variables}
              setChange={setChange}
              setDrafts={setDrafts}
              mailData={mailData}
              setMailData={setMailData}
              selectedNodesCount={selectedNodesCount}
              columnsForMultiSelect={columnsForMultiSelect}
              showAlert={showAlert}
            />
          </InputAreaWrapper>
          <BottomToolbar
            mailData={mailData}
            setMailData={setMailData}
            templates={templates}
            timezones={timezones}
            populate={populate}
            from_emails={from_emails}
            reconnectAccount={reconnectAccount}
            disconnectAccount={disconnectAccount}
            deleteAccount={deleteAccount}
            deleteTemplate={deleteTemplate}
            create={create}
            addAccount={addAccount}
            setChange={setChange}
            change={change}
            preview={preview}
            store={store}
            showAlert={showAlert}
            drafts={drafts}
            toggleNewTemplate={toggleNewTemplate}
            isLoadingFetchDrafts={isLoadingFetchDrafts}
          />
        </StyledBox>
      </Modal>
    </Fragment>
  );
};

export default MailModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 82vw;
    max-height: 95vh;
    overflow: hidden;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;

const InputAreaWrapper = styled.div`
  && {
    margin-bottom: 5px;
    overflow: auto;
    max-height: 75vh;
  }
`;